import { render, staticRenderFns } from "./Textarea.htm?vue&type=template&id=400aad9d&scoped=true&"
import script from "./Textarea.ts?vue&type=script&lang=js&"
export * from "./Textarea.ts?vue&type=script&lang=js&"
import style0 from "./Textarea.scss?vue&type=style&index=0&id=400aad9d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400aad9d",
  null
  
)

export default component.exports